import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  directMessageId: string;
};

const request = ({ directMessageId }: RequestDataType) => {
  return new ApiClient()
    .post<ResponseMessageType>(
      `/api/members/direct_messages/${directMessageId}/likes`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersDirectMessagesLikesCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<ResponseMessageType, RequestDataType> => {
  return useMutation(request, { ...options });
};
